export default __webpack_public_path__ + "static/media/ReadyAPI-Logo.c67c016b.svg";